import React, { createContext, useContext, useState, ReactNode } from "react";
import { WarningModal } from "../../../../components/WarningModal";
import { useTranslation } from "react-i18next";

type UnsavedChangesWarningModalContextType = {
  openUnsavedChangesModal: ATVoidFunction<VoidFunction>;
};

const UnsavedChangesWarningModalContext = createContext<
  UnsavedChangesWarningModalContextType | undefined
>(undefined);

export const useUnsavedChangesWarningModalContext = () => {
  const context = useContext(UnsavedChangesWarningModalContext);
  if (!context)
    throw new Error(
      "useUnsavedChangesWarningModalContext must be used inside UnsavedChangesWarningModalProvider",
    );
  return context;
};

type UnsavedChangesWarningModalProviderProps = {
  children: ReactNode;
};

export const UnsavedChangesWarningModalProvider: React.FC<
  UnsavedChangesWarningModalProviderProps
> = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [confirmHandler, setConfirmHandler] = useState<VoidFunction>(() => {});
  const { t } = useTranslation(undefined, { keyPrefix: "unSavedChangesModal" });

  const openUnsavedChangesModal = (onConfirm: VoidFunction) => {
    setConfirmHandler(() => onConfirm);
    setOpen(true);
  };

  return (
    <UnsavedChangesWarningModalContext.Provider
      value={{ openUnsavedChangesModal }}
    >
      {children}

      <WarningModal
        isOpen={open}
        onClose={() => setOpen(false)}
        title={t("title")}
        description={t("description")}
        onConfirm={() => {
          confirmHandler();
          setOpen(false);
        }}
      />
    </UnsavedChangesWarningModalContext.Provider>
  );
};
